import { ITableState, SkeletonTableRow, TableCellSkeleton } from '/shared/Table';

export function GenericTableSkeletonRows<D>({ renderColumnsCount, rowsPerPage }: ITableState<D>) {
  const cols = () => (
    <>
      {Array.from({ length: renderColumnsCount }, (_, idx) => (
        <TableCellSkeleton key={idx} />
      ))}
    </>
  );

  return (
    <>
      {Array.from({ length: rowsPerPage }, (_, idx) => (
        <SkeletonTableRow key={idx} data-testid={`skeleton-row-${idx}`}>
          {cols()}
        </SkeletonTableRow>
      ))}
    </>
  );
}
